import { takeLatest, call, put } from "redux-saga/effects";
import { loader, toast } from "../common/common-reducer";
import { HttpResponse } from "../common/response-model";
import { ProfileService } from "./service";
import {
  actionLoadingResponse,
  addressListResponse,
  bookingDetailsResponse,
  cityListResponse,
  crmCityListResponse,
  crmStateListResponse,
  getProfileResponse,
  historyListLoadingResponse,
  orderListResponse,
  totalOrdersResponse,
  patientListResponse,
  paymentHistoryResponse,
  totalPaymentHistoryResponse,
  pincodeListResponse,
  profileMasterResponse,
  stateListResponse,
  termConditionResponse,
  userActivityLogResponse,
  cartListResponse,
  refundDetailsResponse
} from "./reducer";
import {
  addAddressAction,
  addFamilyMemberAction,
  addressListAction,
  bookingDetailsAction,
  cancelBookingAction,
  cityListAction,
  createPatientAction,
  deleteMemberAction,
  editProfileAction,
  getProfileAction,
  orderListAction,
  patientListAction,
  paymentHistoryAction,
  pincodeListAction,
  profileMasterAction,
  refundBookingAction,
  reportListAction,
  stateListAction,
  termConditionAction,
  updateAddressAction,
  updateFamilyMemberAction,
  updatePatientAction,
  userActivityLogAction,
  cartListAction,
  refundDetailsAction,
} from "./action";
import { getUser, setUserDataInLocal } from "../../constant/utils";

export function* getProfile(data: any) {
  try {
    yield put(loader(true));
    let payload = data.payload;
    let { Request } = payload;
    let res: HttpResponse<any> = yield call(
      ProfileService.getInstance().getProfile,
      Request?.id
    );
    let response: any = res;
    yield put(getProfileResponse(response?.Result?.User || {}));
    yield put(loader(false));
  } catch (err: any) {
    yield put(getProfileResponse({}));
    yield put(loader(false));
    yield put(toast({ message: err.message, type: "error" }));
  }
}
export function* editProfile(data: any) {
  try {
    yield put(loader(true));
    let payload = data.payload;
    let { id, Request } = payload;
    let res: HttpResponse<any> = yield call(
      ProfileService.getInstance().editProfile,
      id,
      Request
    );
    let response: any = res;
    if (response?.Success == "True") {
      yield put(toast({ message: "Updated Successfully", type: "success" }));
      yield setUserDataInLocal(response?.Result?.User);
      yield call(getProfile, { payload: { Request: { id: id } } });
    } else {
      yield put(toast({ message: response?.Message, type: "error" }));
    }
    yield put(loader(false));
  } catch (err: any) {
    yield put(loader(false));
    yield put(toast({ message: err.message, type: "error" }));
  }
}
export function* patientList(data: any) {
  let payload = data.payload;
  let { Request, onSuccess, onError } = payload;
  try {
    yield put(loader(true));
    let res: HttpResponse<any> = yield call(
      ProfileService.getInstance().patientList,
      Request
    );
    let response: any = res;
    yield put(patientListResponse(response?.Result?.data?.results || []));
    yield put(loader(false));
    onSuccess && onSuccess(response?.Result?.data?.results?.[0]);
  } catch (err: any) {
    yield put(patientListResponse([]));
    yield put(loader(false));
    yield put(toast({ message: err.message, type: "error" }));
    onError && onError(err);
  }
}

export function* createPatient(data: any) {
  const USER = getUser();
  let payload = data.payload;
  let { Request, onSuccess, onError } = payload;
  try {
    yield put(loader(true));
    let res: HttpResponse<any> = yield call(
      ProfileService.getInstance().createPatient,
      Request
    );
    let response: any = res;
    if (!response?.Result?.error) {
      onSuccess && onSuccess(response?.Result);
      yield put(toast({ message: "Created Successfully", type: "success" }));
      yield setUserDataInLocal(response?.Result?.data?.results);
      yield call(patientList, {
        payload: { Request: { mobile_no: USER?.MobileNo } },
      });
    } else {
      onError && onError(response?.Result);
      yield put(toast({ message: response?.Result?.message, type: "error" }));
    }
    yield put(loader(false));
  } catch (err: any) {
    yield put(loader(false));
    yield put(toast({ message: err.message, type: "error" }));
    onError && onError(err);
  }
}
export function* updatePatient(data: any) {
  const USER = getUser();
  let payload = data.payload;
  let { Request, onSuccess, onError } = payload;
  try {
    yield put(loader(true));
    let res: HttpResponse<any> = yield call(
      ProfileService.getInstance().updatePatient,
      Request
    );
    let response: any = res;
    if (!response?.Result?.error) {
      onSuccess && onSuccess(response?.Result);
      yield put(toast({ message: "Updated Successfully", type: "success" }));
      yield setUserDataInLocal(response?.Result?.data?.results);
      yield call(patientList, {
        payload: { Request: { mobile_no: USER?.MobileNo } },
      });
    } else {
      onError && onError(response?.Result);
      yield put(toast({ message: response?.Result?.message, type: "error" }));
    }
    yield put(loader(false));
  } catch (err: any) {
    yield put(loader(false));
    yield put(toast({ message: err.message, type: "error" }));
    onError && onError(err);
  }
}
export function* addFamilyMember(data: any) {
  const USER = getUser();
  let payload = data.payload;
  let { Request, onSuccess, onError } = payload;
  try {
    yield put(loader(true));
    let res: HttpResponse<any> = yield call(
      ProfileService.getInstance().addFamilyMember,
      Request
    );
    let response: any = res;
    if (!response?.Result?.error) {
      onSuccess && onSuccess(response?.Result);
     /*  yield put(toast({ message: "Created Successfully", type: "success" })); */
      yield call(patientList, {
        payload: { Request: { mobile_no: USER?.MobileNo } },
      });
    } else {
      onError && onError(response?.Result);
      yield put(toast({ message: response?.Result?.message, type: "error" }));
    }
    yield put(loader(false));
  } catch (err: any) {
    yield put(loader(false));
    yield put(toast({ message: err.message, type: "error" }));
    onError && onError(err);
  }
}
export function* updateFamilyMember(data: any) {
  const USER = getUser();
  let payload = data.payload;
  let { Request, onSuccess, onError } = payload;
  try {
    yield put(loader(true));
    let payload = data.payload;
    let { Request } = payload;
    let res: HttpResponse<any> = yield call(
      ProfileService.getInstance().updateFamilyMember,
      Request
    );
    let response: any = res;
    if (!response?.Result?.error) {
      onSuccess && onSuccess(response?.Result);
      yield put(toast({ message: "Updated Successfully", type: "success" }));
      yield call(patientList, {
        payload: { Request: { mobile_no: USER?.MobileNo } },
      });
    } else {
      onError && onError(response?.Result);
      yield put(toast({ message: response?.Result?.message, type: "error" }));
    }
    yield put(loader(false));
  } catch (err: any) {
    yield put(loader(false));
    yield put(toast({ message: err.message, type: "error" }));
    onError && onError(err);
  }
}
export function* deleteMember(data: any) {
  const USER = getUser();
  let payload = data.payload;
  let { Request, onSuccess, onError } = payload;
  try {
    yield put(loader(true));
    let res: HttpResponse<any> = yield call(
      ProfileService.getInstance().deleteMember,
      Request
    );
    let response: any = res;
    if (!response?.Result?.error) {
      onSuccess && onSuccess(response?.Result);
      yield put(toast({ message: "Deleted Successfully", type: "success" }));
      yield call(patientList, {
        payload: { Request: { mobile_no: USER?.MobileNo } },
      });
    } else {
      onError && onError(response?.Result);
      yield put(toast({ message: response?.Result?.message, type: "error" }));
    }
    yield put(loader(false));
  } catch (err: any) {
    yield put(loader(false));
    yield put(toast({ message: err.message, type: "error" }));
    onError && onError(err);
  }
}

export function* orderList(data: any) {
  try {
    yield put(historyListLoadingResponse(true));
    yield put(loader(true));
    let payload = data.payload;
    let {Request } = payload;
    let res: HttpResponse<any> = yield call(
      ProfileService.getInstance().orderList,
      Request
    );
    let response: any = res;
    yield put(orderListResponse(response?.Result));
    yield put(totalOrdersResponse(response));
    yield put(loader(false));
    yield put(historyListLoadingResponse(false));
  } catch (err: any) {
    yield put(orderListResponse([]));
    yield put(loader(false));
    yield put(historyListLoadingResponse(false));
    yield put(toast({ message: err.message, type: "error" }));
  }
}
export function* addressList(data: any) {
  try {
    yield put(loader(true));
    let payload = data.payload;
    let { Request } = payload;
    let res: HttpResponse<any> = yield call(
      ProfileService.getInstance().addressList,
      Request
    );
    let response: any = res;
    yield put(addressListResponse(response?.Result || []));
    yield put(loader(false));
  } catch (err: any) {
    yield put(addressListResponse([]));
    yield put(loader(false));
    yield put(toast({ message: err.message, type: "error" }));
  }
}
export function* addAddress(data: any) {
  let payload = data.payload;
  let { Request, onSuccess, onError } = payload;
  try {
    yield put(loader(true));
    let res: HttpResponse<any> = yield call(
      ProfileService.getInstance().addAddress,
      Request
    );
    let response: any = res;
    if (response?.Success == "True") {
      onSuccess && onSuccess(response?.Result);
      yield put(toast({ message: "Created Successfully", type: "success" }));
    } else {
      onError && onError(response?.Result);
      yield put(toast({ message: response?.Message, type: "error" }));
    }
    yield put(loader(false));
  } catch (err: any) {
    yield put(loader(false));
    yield put(toast({ message: err.message, type: "error" }));
    onError && onError(err);
  }
}
export function* updateAddress(data: any) {
  let payload = data.payload;
  let { Request, onSuccess, onError } = payload;
  try {
    yield put(loader(true));
    let res: HttpResponse<any> = yield call(
      ProfileService.getInstance().updateAddress,
      Request
    );
    let response: any = res;
    if (response?.Success == "True") {
      onSuccess && onSuccess(response?.Result);
      yield put(toast({ message: "Updated Successfully", type: "success" }));
    } else {
      onError && onError(response?.Result);
      yield put(toast({ message: response?.Message, type: "error" }));
    }
    yield put(loader(false));
  } catch (err: any) {
    yield put(loader(false));
    yield put(toast({ message: err.message, type: "error" }));
    onError && onError(err);
  }
}
export function* termCondition(data: any) {
  try {
    yield put(loader(true));
    let payload = data.payload;
    let { Request } = payload;
    let res: HttpResponse<any> = yield call(
      ProfileService.getInstance().termCondition,
      Request
    );
    let response: any = res;
    yield put(termConditionResponse(response?.Result));
    yield put(loader(false));
  } catch (err: any) {
    yield put(termConditionResponse([]));
    yield put(loader(false));
    yield put(toast({ message: err.message, type: "error" }));
  }
}
export function* reportList(data: any) {
  try {
    yield put(loader(true));
    let payload = data.payload;
    let { Request } = payload;
    let res: HttpResponse<any> = yield call(
      ProfileService.getInstance().patientList,
      Request
    );
    let response: any = res;
    yield put(patientListResponse(response?.Result));
    yield put(loader(false));
  } catch (err: any) {
    yield put(patientListResponse([]));
    yield put(loader(false));
    yield put(toast({ message: err.message, type: "error" }));
  }
}
export function* paymentHistory(data: any) {
  try {
    yield put(loader(true));
    let payload = data.payload;
    let { Request } = payload;
    let res: HttpResponse<any> = yield call(
      ProfileService.getInstance().paymentHistory,
      Request
    );
    let response: any = res;
    yield put(paymentHistoryResponse(response?.Result));
    yield put(totalPaymentHistoryResponse(response));
    yield put(loader(false));
  } catch (err: any) {
    yield put(paymentHistoryResponse([]));
    yield put(loader(false));
    yield put(toast({ message: err.message, type: "error" }));
  }
}
export function* userActivityLog(data: any) {
  try {
    yield put(loader(true));
    let payload = data.payload;
    let { Request } = payload;
    let res: HttpResponse<any> = yield call(
      ProfileService.getInstance().userActivityLog,
      Request
    );
    let response: any = res;
    yield put(userActivityLogResponse(response?.Result?.ActivityLogs || []));
    yield put(loader(false));
  } catch (err: any) {
    yield put(userActivityLogResponse([]));
    yield put(loader(false));
    yield put(toast({ message: err.message, type: "error" }));
  }
}
export function* profileMaster(data: any) {
  try {
    yield put(loader(true));
    let payload = data.payload;
    let { Request } = payload;
    let res: HttpResponse<any> = yield call(
      ProfileService.getInstance().profileMaster,
      Request
    );
    let response: any = res;
    yield put(profileMasterResponse(response?.Result?.data?.results));
    yield put(loader(false));
  } catch (err: any) {
    yield put(profileMasterResponse([]));
    yield put(loader(false));
    yield put(toast({ message: err.message, type: "error" }));
  }
}
export function* cityList(data: any) {
  let payload = data.payload;
  let { Request, onSuccess, onError } = payload;
  try {
    yield put(loader(true));
    yield put(cityListResponse([]));
    yield put(crmCityListResponse([]));
    let res: HttpResponse<any> = yield call(
      ProfileService.getInstance().cityList,
      Request
    );
    let response: any = res;
    if (response?.Success == "True") {
      yield put(cityListResponse(response?.Cities));
      yield put(
        crmCityListResponse(response?.Result?.CrmCities?.data?.results)
      );
      onSuccess && onSuccess(response?.Result);
    } else {
      yield put(cityListResponse([]));
      yield put(crmCityListResponse([]));
    }
    yield put(loader(false));
  } catch (err: any) {
    yield put(cityListResponse([]));
    yield put(crmCityListResponse([]));
    yield put(loader(false));
    yield put(toast({ message: err.message, type: "error" }));
    onError && onError(err);
  }
}
export function* pincodeList(data: any) {
  let payload = data.payload;
  let { Request, onSuccess, onError } = payload;
  try {
    yield put(loader(true));
    yield put(pincodeListResponse([]));
    let res: HttpResponse<any> = yield call(
      ProfileService.getInstance().pincodeList,
      Request
    );
    let response: any = res;
    if (response?.Success == "True") {
      yield put(pincodeListResponse(response?.Result?.pincodes));
      onSuccess && onSuccess(response?.Result);
    } else {
      yield put(pincodeListResponse([]));
    }
    yield put(loader(false));
  } catch (err: any) {
    yield put(pincodeListResponse([]));
    yield put(loader(false));
    yield put(toast({ message: err.message, type: "error" }));
    onError && onError(err);
  }
}
export function* stateList(data: any) {
  let payload = data.payload;
  let { Request, onSuccess, onError } = payload;
  try {
    yield put(loader(true));
    yield put(cityListResponse([]));
    yield put(crmCityListResponse([]));
    let res: HttpResponse<any> = yield call(
      ProfileService.getInstance().stateList,
      Request
    );
    let response: any = res;
    yield put(stateListResponse(response?.States));
    yield put(crmStateListResponse(response?.Result?.CrmStates?.data?.results));
    onSuccess && onSuccess(response?.Result);
    yield put(loader(false));
  } catch (err: any) {
    yield put(stateListResponse([]));
    yield put(crmStateListResponse([]));
    yield put(loader(false));
    yield put(toast({ message: err.message, type: "error" }));
    onError && onError(err);
  }
}
export function* cancelBooking(data: any) {
  let payload = data.payload;
  let { Request, onSuccess, onError } = payload;
  try {
    yield put(actionLoadingResponse(true));
    yield put(loader(true));
    let res: HttpResponse<any> = yield call(
      ProfileService.getInstance().cancelBooking,
      Request
    );
    let response: any = res;
    if (response?.Success == "True") {
      onSuccess && onSuccess(response?.Result);
      /* yield put(toast({ message: response.Message, type: "success" })); */
    } else {
      onError && onError(response?.Result);
      yield put(toast({ message: response?.Message, type: "error" }));
    }
    yield put(actionLoadingResponse(false));
    yield put(loader(false));
  } catch (err: any) {
    yield put(actionLoadingResponse(false));
    yield put(loader(false));
    yield put(toast({ message: err.message, type: "error" }));
    onError && onError(err);
  }
}
export function* refundBooking(data: any) {
  let payload = data.payload;
  let { Request, onSuccess, onError } = payload;
  try {
    yield put(actionLoadingResponse(true));
    yield put(loader(true));
    let res: HttpResponse<any> = yield call(
      ProfileService.getInstance().refundBooking,
      Request
    );
    let response: any = res;
    if (response?.Success == "True") {
      onSuccess && onSuccess(response?.Result);
    } else {
      onError && onError(response?.Result);
      yield put(toast({ message: response?.Message, type: "error" }));
    }
    yield put(actionLoadingResponse(false));
    yield put(loader(false));
  } catch (err: any) {
    yield put(actionLoadingResponse(false));
    yield put(loader(false));
    yield put(toast({ message: err.message, type: "error" }));
    onError && onError(err);
  }
}

export function* bookingDetails(data: any) {
  let payload = data.payload;
  let { Request, onSuccess, onError } = payload;
  try {
    yield put(actionLoadingResponse(true));
    yield put(bookingDetailsResponse({}));
    yield put(loader(true));
    let res: HttpResponse<any> = yield call(
      ProfileService.getInstance().bookingDetails,
      Request
    );
    let response: any = res;
    if (response?.Success == "True") {
      yield put(bookingDetailsResponse(response?.Result || {}));
      yield put(actionLoadingResponse(false));
      onSuccess && onSuccess(response?.Result);
    } else {
      yield put(bookingDetailsResponse({}));
      yield put(toast({ message: response?.Message, type: "error" }));
      yield put(actionLoadingResponse(false));
      onError && onError(response?.Result);
    }
    yield put(loader(false));
  } catch (err: any) {
    yield put(bookingDetailsResponse({}));
    yield put(loader(false));
    yield put(toast({ message: err.message, type: "error" }));
    yield put(actionLoadingResponse(false));
    onError && onError(err);
  }
}
export function* cartList(data: any) {
  let payload = data.payload;
  let { Request, onSuccess, onError } = payload;
  try {
    yield put(loader(true));
    let payload = data.payload;
    let { Request } = payload;
    let res: HttpResponse<any> = yield call(
      ProfileService.getInstance().cartList,
      Request
    );
    let response: any = res;
    if (response.Success === "Failed" && response.Error && response.Error.error && response.Error.error.CartData) {
      yield put(toast({ message: response.Error.error.CartData[0], type: "error" }));
      onError && onError(response.Error);
    } else {
      yield put(cartListResponse(response.Result.CartData?.cart_data || {}));
      onSuccess && onSuccess(response.Result.CartData?.cart_data || {});
    }
    yield put(loader(false));
  } catch (err: any) {
    yield put(cartListResponse({}));
    yield put(loader(false));
    yield put(toast({ message: err.message, type: "error" }));
    onError && onError(err);
    
  }
}
export function* refundDetails(data: any) {
  let payload = data.payload;
  let { Request, onSuccess, onError } = payload;
  try {
    yield put(refundDetailsResponse({}));
    yield put(loader(true));
    let res: HttpResponse<any> = yield call(
      ProfileService.getInstance().refundDetails,
      Request
    );
    let response: any = res;
    // console.log('responseresponse',response);
    if (response?.Success) {
      yield put(refundDetailsResponse(response?.Result || {}));
      onSuccess && onSuccess(response?.Result);
    } else {
      yield put(refundDetailsResponse({}));
      yield put(toast({ message: response?.Result?.error_desc || response?.message, type: "error" }));
      onError && onError(response?.data);
    }
    yield put(loader(false));
  } catch (err: any) {
    yield put(refundDetailsResponse({}));
    yield put(loader(false));
    yield put(toast({ message: err.message, type: "error" }));
    onError && onError(err);
  }
}
export function* profileEffects() {
  yield takeLatest(getProfileAction.type, getProfile);
  yield takeLatest(editProfileAction.type, editProfile);
  yield takeLatest(patientListAction.type, patientList);
  yield takeLatest(createPatientAction.type, createPatient);
  yield takeLatest(updatePatientAction.type, updatePatient);
  yield takeLatest(addFamilyMemberAction.type, addFamilyMember);
  yield takeLatest(updateFamilyMemberAction.type, updateFamilyMember);
  yield takeLatest(deleteMemberAction.type, deleteMember);
  yield takeLatest(orderListAction.type, orderList);
  yield takeLatest(addressListAction.type, addressList);
  yield takeLatest(addAddressAction.type, addAddress);
  yield takeLatest(updateAddressAction.type, updateAddress);
  yield takeLatest(termConditionAction.type, termCondition);
  yield takeLatest(reportListAction.type, reportList);
  yield takeLatest(paymentHistoryAction.type, paymentHistory);
  yield takeLatest(userActivityLogAction.type, userActivityLog);
  yield takeLatest(profileMasterAction.type, profileMaster);
  yield takeLatest(cityListAction.type, cityList);
  yield takeLatest(pincodeListAction.type, pincodeList);
  yield takeLatest(stateListAction.type, stateList);
  yield takeLatest(cancelBookingAction.type, cancelBooking);
  yield takeLatest(refundBookingAction.type, refundBooking);
  yield takeLatest(bookingDetailsAction.type, bookingDetails);
  yield takeLatest(cartListAction.type, cartList);
  yield takeLatest(refundDetailsAction.type, refundDetails);
}

const profileSagas = [call(profileEffects)];

export default profileSagas;
